import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/Ranking.svg'
import _imports_1 from '@/app/ui/assets/svg/whatsapp.svg'


const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "w-full min-w-[1200px]" }
const _hoisted_3 = {
  class: "z-30 bg-gray-lp-1500 sticky top-0 p-2 text-center mobile-freeze-1",
  style: {"width":"120px"}
}
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "text-16px text-black font-bold" }
const _hoisted_6 = { class: "text-10px text-gray-lp-500 font-normal" }
const _hoisted_7 = {
  class: "z-30 bg-gray-lp-1500 sticky top-0 p-2 text-left mobile-freeze-2",
  style: {"width":"300px"}
}
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "text-16px text-black font-bold" }
const _hoisted_10 = {
  class: "text-left bg-gray-lp-1500 sticky top-0 px-4 py-2",
  style: {"width":"280px"}
}
const _hoisted_11 = { class: "text-10px text-gray-lp-500 font-normal" }
const _hoisted_12 = { class: "flex flex-row items-center justify-center" }
const _hoisted_13 = { class: "text-10px text-gray-lp-500 font-normal" }
const _hoisted_14 = { class: "flex flex-row items-center justify-center" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  class: " bg-white p-2 text-center",
  style: {"width":"20px","height":"60px"}
}
const _hoisted_17 = {
  class: " bg-white p-2 text-center",
  style: {"width":"220px","height":"60px"}
}
const _hoisted_18 = {
  class: " bg-white p-2 text-center",
  style: {"width":"250px","height":"60px"}
}
const _hoisted_19 = {
  class: " bg-white p-2 text-center",
  style: {"width":"200px","height":"60px"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  colspan: "5",
  class: " bg-white p-2 text-center",
  style: {"height":"600px"}
}
const _hoisted_22 = { class: "flex flex-col items-center justify-center" }
const _hoisted_23 = { class: "text-gray-lp-300" }
const _hoisted_24 = { class: "text-gray-lp-600" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = {
  colspan: "5",
  class: " bg-white p-2 text-center",
  style: {"height":"600px"}
}
const _hoisted_27 = { key: 3 }
const _hoisted_28 = {
  class: "z-10 bg-white p-2 text-left mobile-freeze-1",
  style: {"width":"48px"}
}
const _hoisted_29 = { class: "flex flex-row space-x-1 items-center" }
const _hoisted_30 = { class: "flex items-center justify-center gap-x-1 relative" }
const _hoisted_31 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "Ranking",
  class: "w-8 h-6"
}, null, -1)
const _hoisted_32 = { class: "text-10px text-black font-bold absolute top-2" }
const _hoisted_33 = {
  class: "z-10 bg-white p-2 text-left mobile-freeze-2",
  style: {"width":"280px"}
}
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = { class: "text-14px text-black flex flex-row flex-wrap items-center gap-1 w-full" }
const _hoisted_36 = { class: "flex flex-row items-center gap-1 whitespace-nowrap" }
const _hoisted_37 = { class: "text-10px text-gray-lp-500 font-normal italic" }
const _hoisted_38 = {
  class: "text-left px-4 py-2 bg-white",
  style: {"width":"180px"}
}
const _hoisted_39 = { class: "flex flex-wrap gap-2" }
const _hoisted_40 = { class: "text-center px-4 py-2 bg-white font-14px" }
const _hoisted_41 = { class: "text-10px text-gray-lp-500 font-normal" }
const _hoisted_42 = { class: "flex flex-row items-center justify-center gap-1" }
const _hoisted_43 = { class: "text-10px text-gray-lp-500 font-normal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_EmptyState = _resolveComponent("EmptyState")!

  return (_openBlock(), _createBlock("div", {
    onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args))),
    ref: "scrollContainer",
    class: "w-full bg-gray-lp-200 rounded-lg font-montserrat min-w-[1200px] h-800px overflow-auto scroll"
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("table", _hoisted_2, [
        _createVNode("thead", null, [
          _createVNode("tr", null, [
            _createVNode("th", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("dashboard.customer.ranking")), 1),
                _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.customer.dataLabel")) + " " + _toDisplayString(_ctx.data.data[0]?.performance.previousPeriode[0].month), 1)
              ])
            ]),
            _createVNode("th", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("dashboard.customer.pelanggan")), 1)
              ])
            ]),
            _createVNode("th", _hoisted_10, [
              _createTextVNode(_toDisplayString(_ctx.$t("dashboard.customer.labelPelanggan")) + " ", 1),
              _createVNode("p", _hoisted_11, " Data " + _toDisplayString(_ctx.data.data[0]?.performance.previousPeriode[0].month), 1)
            ]),
            _createVNode("th", {
              class: "z-20 bg-gray-lp-1500 sticky top-0 p-2 text-center",
              style: {"width":"200px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sortCurrent && _ctx.sortCurrent(...args)))
            }, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("dashboard.customer.periodeSaatIni")) + " ", 1),
                  _createVNode("p", _hoisted_13, " 1 - " + _toDisplayString(_ctx.currentDateFormatted), 1)
                ]),
                (_ctx.currentSortDirection === 'desc')
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: require('@/app/ui/assets/svg/ics_o_arrow_up.svg'),
                      alt: "Sort Desc",
                      class: "w-4 h-4 opacity-60"
                    }, null, 8, ["src"]))
                  : (_ctx.currentSortDirection === 'asc')
                    ? (_openBlock(), _createBlock("img", {
                        key: 1,
                        src: require('@/app/ui/assets/svg/ics_o_arrow_down.svg'),
                        alt: "Sort Asc",
                        class: "w-4 h-4 opacity-60"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(_component_Icons, {
                        key: 2,
                        name: "sort",
                        class: "w-5 h-5 opacity-60"
                      }))
              ])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.data[0]?.performance.previousPeriode, (data, i) => {
              return (_openBlock(), _createBlock("th", {
                key: data.month,
                class: "z-20 bg-gray-lp-1500 sticky top-0 p-2 text-center",
                style: {"width":"200px"},
                onClick: ($event: any) => (_ctx.sortPrevious(i))
              }, [
                _createVNode("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(data.month) + " ", 1),
                  (_ctx.previousSortDirection(i) === 'desc')
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: require('@/app/ui/assets/svg/ics_o_arrow_up.svg'),
                        alt: "Sort Desc",
                        class: "w-4 h-4 opacity-60"
                      }, null, 8, ["src"]))
                    : (_ctx.previousSortDirection(i) === 'asc')
                      ? (_openBlock(), _createBlock("img", {
                          key: 1,
                          src: require('@/app/ui/assets/svg/ics_o_arrow_down.svg'),
                          alt: "Sort Asc",
                          class: "w-4 h-4 opacity-60"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createBlock(_component_Icons, {
                          key: 2,
                          name: "sort",
                          class: "w-5 h-5 opacity-60"
                        }))
                ])
              ], 8, ["onClick"]))
            }), 128))
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createBlock("tbody", _hoisted_15, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(10, (index) => {
                return _createVNode("tr", { key: index }, [
                  _createVNode("td", _hoisted_16, [
                    _createVNode(_component_skeleton, {
                      width: "18.5rem",
                      height: "1.2rem"
                    })
                  ]),
                  _createVNode("td", _hoisted_17, [
                    _createVNode(_component_skeleton, {
                      width: "18.5rem",
                      height: "1.2rem"
                    })
                  ]),
                  _createVNode("td", _hoisted_18, [
                    _createVNode(_component_skeleton, {
                      width: "18.5rem",
                      height: "1.2rem"
                    })
                  ]),
                  _createVNode("td", _hoisted_19, [
                    _createVNode(_component_skeleton, {
                      width: "18.5rem",
                      height: "1.2rem"
                    })
                  ])
                ])
              }), 64))
            ]))
          : (_ctx.error)
            ? (_openBlock(), _createBlock("tbody", _hoisted_20, [
                _createVNode("tr", null, [
                  _createVNode("td", _hoisted_21, [
                    _createVNode("div", _hoisted_22, [
                      _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("dashboard.customer.systemError")), 1),
                      _createVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("dashboard.customer.systemErrorHint")), 1),
                      _createVNode(_component_LpButton, {
                        class: "mt-4",
                        color: "red-lp-100",
                        textColor: "white",
                        title: _ctx.$t('dashboard.customer.reloadPage'),
                        onClick: _ctx.reloadPage
                      }, null, 8, ["title", "onClick"])
                    ])
                  ])
                ])
              ]))
            : (!_ctx.data.data.length)
              ? (_openBlock(), _createBlock("tbody", _hoisted_25, [
                  _createVNode("tr", null, [
                    _createVNode("td", _hoisted_26, [
                      _createVNode(_component_EmptyState, {
                        icon: "noData_empty",
                        customMessage: _ctx.$t('dashboard.customer.emptyMessage')
                      }, null, 8, ["customMessage"])
                    ])
                  ])
                ]))
              : (_openBlock(), _createBlock("tbody", _hoisted_27, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data.data, (item, index) => {
                    return (_openBlock(), _createBlock("tr", {
                      class: "border-b border-t",
                      key: index
                    }, [
                      _createVNode("td", _hoisted_28, [
                        _createVNode("div", _hoisted_29, [
                          _createVNode("div", _hoisted_30, [
                            _hoisted_31,
                            _createVNode("p", _hoisted_32, _toDisplayString(item.rank), 1)
                          ]),
                          (item.rankChange !== 0)
                            ? (_openBlock(), _createBlock("img", {
                                key: 0,
                                src: 
                    item.rankChange > 0
                      ? require('@/app/ui/assets/svg/arrow-up-green.svg')
                      : require('@/app/ui/assets/svg/arrow-down-red.svg')
                  ,
                                alt: "",
                                class: "w-3 h-3"
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true),
                          (item.rankChange !== 0)
                            ? (_openBlock(), _createBlock("div", {
                                key: 1,
                                class: 
                    `text-10px ${
                      item.rankChange > 0 ? 'bg-green-lp-100' : 'bg-red-lp-2700'
                    } text-white font-normal rounded-xl px-2`
                  
                              }, _toDisplayString(item.rankChange), 3))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("td", _hoisted_33, [
                        _createVNode("div", _hoisted_34, [
                          _createVNode("div", _hoisted_35, [
                            _createVNode("span", null, _toDisplayString(item.name), 1),
                            _createVNode("span", _hoisted_36, [
                              _createTextVNode(" (" + _toDisplayString(_ctx.maskPhoneNumber(item.phoneNumber)) + ") ", 1),
                              _createVNode("img", {
                                onClick: ($event: any) => (_ctx.openWhatsApp(item.phoneNumber)),
                                src: _imports_1,
                                alt: "Whatsapp",
                                class: "w-4 h-4 cursor-pointer"
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _createVNode("p", _hoisted_37, _toDisplayString(_ctx.$t("dashboard.customer.lastSend")) + " " + _toDisplayString(_ctx.formatedDate(item.lastBooking)), 1)
                        ])
                      ]),
                      _createVNode("td", _hoisted_38, [
                        _createVNode("div", _hoisted_39, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mapTagsToChips(item.tag), (chip, i) => {
                            return (_openBlock(), _createBlock("span", {
                              key: i,
                              class: ["text-xs px-2 py-1 rounded-lg", [chip?.bg, chip?.text, chip?.border]]
                            }, _toDisplayString(chip?.label), 3))
                          }), 128))
                        ])
                      ]),
                      _createVNode("td", _hoisted_40, [
                        _createVNode("div", null, _toDisplayString(_ctx.formatCurrency(item.performance.currentPeriode.amount)), 1),
                        _createVNode("div", _hoisted_41, _toDisplayString(item.performance.currentPeriode.stt) + " STT (" + _toDisplayString(item.performance.currentPeriode.weightKg) + " kg) ", 1)
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.performance.previousPeriode, (data) => {
                        return (_openBlock(), _createBlock("td", {
                          key: data.month,
                          class: "text-center px-4 py-2 bg-white font-14px"
                        }, [
                          _createVNode("div", _hoisted_42, [
                            _createTextVNode(_toDisplayString(_ctx.formatCurrency(data.amount)) + " ", 1),
                            (data.growthPercentage !== 0)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: 
                    data.growthPercentage > 0
                      ? require('@/app/ui/assets/svg/arrow-up-green.svg')
                      : require('@/app/ui/assets/svg/arrow-down-red.svg')
                  ,
                                  alt: "",
                                  class: "w-3 h-3"
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            _createVNode("p", {
                              class: 
                    `text-10px ${
                      data.growthPercentage > 0
                        ? 'text-green-lp-100'
                        : 'text-red-lp-2700'
                    } font-normal rounded-xl px-2`
                  
                            }, _toDisplayString(data.growthPercentage !== 0
                      ? `${data.growthPercentage}%`
                      : ""), 3)
                          ]),
                          _createVNode("div", _hoisted_43, _toDisplayString(data.stt) + " STT (" + _toDisplayString(data.weightKg) + " kg) ", 1)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ]))
      ])
    ])
  ], 544))
}